// src/app/services/brand/monitoring-history-api.ts
//
// Brand Monitoring (antenna) run history: list past runs for a brand and load a
// specific run's full aggregated payload. Powers the run switcher in the antenna
// header so users can move back through previous monitoring runs over time.
import { apiFetch } from "@/api/api-fetch";

export interface MonitoringHistoryItem {
  id: number;
  brandName: string;
  createdAt: string | null;
  status: string | null;
  /** Account that executed the run (may differ from the current user). */
  username?: string | null;
}

export interface MonitoringRunDetails {
  id: number;
  brandName: string;
  selectedModels: string[];
  createdAt: string | null;
  status: string | null;
  /** The full aggregated brand-monitoring payload (same shape as antennaData). */
  data: any;
}

/**
 * Past monitoring runs for a brand, newest first. Brand-scoped server-side so a
 * user with many brands still gets that brand's full recent history.
 */
export async function fetchMonitoringHistory(
  brand: string,
  limit = 50,
): Promise<MonitoringHistoryItem[]> {
  const params = new URLSearchParams();
  if (brand) params.set("brand", brand);
  params.set("limit", String(limit));
  const res = await apiFetch<{ items: MonitoringHistoryItem[] }>(
    `/monitoring/history?${params.toString()}`,
  );
  return Array.isArray(res?.items) ? res.items : [];
}

/** Full aggregated payload for a single past run. */
export async function fetchMonitoringRun(runId: number): Promise<MonitoringRunDetails> {
  return apiFetch<MonitoringRunDetails>(`/monitoring/runs/${runId}`);
}
